import "./App.css";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import Home from "./pages";
import CalculatePage from "./pages/calculate";

function App() {
  return (
    <Router>
      <Switch>
        <Route path="/" component={Home} exact />
        <Route path="/calculate" component={CalculatePage} exact />
      </Switch>
    </Router>
  );
}

export default App;
